import { useTranslation } from '@cobliteam/i18n';
import { DrawerClose, DrawerHeader, DrawerTitle } from '@cobliteam/ui/components/Drawer';
import Typography from '@cobliteam/ui/components/Typography';
import type { DriverDrawerType } from '../types';

interface DriverDrawerHeaderProps {
  type: DriverDrawerType;
  title?: string;
}

const DriverDrawerHeader = ({ type = 'add', title }: DriverDrawerHeaderProps) => {
  const { t } = useTranslation('drivers');
  const defaultTitle = type === 'add' ? t('add_driver') : t('edit_driver');
  const resolvedTitle = title ?? defaultTitle;

  return (
    <DrawerHeader>
      <DrawerTitle>
        <Typography variant='heading-lg'>{resolvedTitle}</Typography>
      </DrawerTitle>
      <DrawerClose />
    </DrawerHeader>
  );
};

export default DriverDrawerHeader;
